// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GeneratePdfFromTemplateRequest {
    static getAttributeTypeMap() {
        return GeneratePdfFromTemplateRequest.attributeTypeMap;
    }
}
GeneratePdfFromTemplateRequest.discriminator = undefined;
GeneratePdfFromTemplateRequest.attributeTypeMap = [
    {
        "name": "filename",
        "baseName": "filename",
        "type": "string"
    },
    {
        "name": "template",
        "baseName": "template",
        "type": "string"
    },
    {
        "name": "contents",
        "baseName": "contents",
        "type": "Array<GeneratePdfFromTemplateRequestContent>"
    }
];
//# sourceMappingURL=generatePdfFromTemplateRequest.js.map